import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { WaterMeterActivityStatus } from "types/dto";

const STYLES: Record<number, { key: string; className: string }> = {
  [WaterMeterActivityStatus.Active]: {
    key: "enum-Active",
    className: "bg-green-100 text-green-20",
  },
  [WaterMeterActivityStatus.NotActive]: {
    key: "enum-NotActive",
    className: "bg-error-100 text-red-20",
  },
  [WaterMeterActivityStatus.NeverSeen]: {
    key: "enum-NeverSeen",
    className: "bg-gray-110 text-gray-20",
  },
};

export const ActivityStatusBadge = ({
  value,
}: {
  value?: WaterMeterActivityStatus;
}) => {
  const { t } = useTranslation();
  const s = value != null ? STYLES[value] : undefined;
  if (!s) return null;
  return (
    <span
      className={clsx(
        "inline-block rounded-full px-2 py-0.5 text-xs font-medium",
        s.className
      )}
    >
      {t(s.key)}
    </span>
  );
};

export default ActivityStatusBadge;
